import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { IsNull } from './isNull';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = "isNull";

@Component({
    selector: 'app-is-null',
    templateUrl: './is-null.component.html',
    styleUrls: ['./is-null.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ClickatellFormValidationComponent, ActiveFormDirective, CMSComponent, NextSelectorComponent]
})
export class IsNullComponent extends NodeBuilder implements OnInit {

  isNullForm: UntypedFormGroup

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: { [index: string]: any }) {
    this.isNullForm = IsNull.toForm(stepData, this.canEdit);

    if ( this.isNullForm.get('yes').value === newStepValue) {
      this.isNullForm.get('yes').setValue('step' + this.getNextStep());
    }
    if ( this.isNullForm.get('no').value === newStepValue) {
      this.isNullForm.get('no').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const formData = this.isNullForm.getRawValue();
    return new IsNull(formData).nodeData;
  }

  get isNodeValid(): boolean {
    this.isNullForm.markAllAsTouched();
    return this.isNullForm.valid;
  }

}
